module.exports = __webpack_public_path__ + "static/media/subOutlook1.c6538b68.png";